<template>
  <div>
    <b-row align-v="center">
      <b-col
        class="m-0 p-0"
        cols="8"
      >
        <CheckBoxConfiguration
          :controller="FitStepGraph"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="FitStepGraph.value"
        class="m-0 p-0"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="FitStepExpanded=!FitStepExpanded"
        >
          <b-icon
            v-if="FitStepExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row
      v-if="FitStepGraph.value"
      align-v="center"
      class="ml-2"
    >
      <b-button
        v-b-tooltip.hover.top="'Open the interactive window'"
        size="sm"
        variant="info"
        @click="openCronoConfig"
      >
        <b-icon
          icon="gear-fill"
          aria-hidden="true"
        /> Configure Events
      </b-button>
    </b-row>
    <b-row v-if="FitStepGraph.value">
      <b-collapse
        v-model="FitStepExpanded"
        class="ml-2 mb-2 expanded-info p-1 w-100"
      >
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
    <b-row
      v-if="FitStepGraph.value"
      align-v="center"
      class="ml-0"
    >
      <CheckBoxConfiguration
        :controller="PredictTimeSeriesCtller"
        :switchprop="true"
      />
    </b-row>
    <b-row
      v-if="FitStepGraph.value"
      align-v="center"
      class="ml-0"
    >
      <CheckBoxConfiguration
        :controller="ExtractedStadisticalEvalCtller"
        :switchprop="true"
      />
    </b-row>
    <StatisticalEvaluation
      v-if="FitStepGraph.value"
      :sectionconfig="sectionconfig"
      :fitname="fitName"
    />
    <b-row
      v-if="FitStepGraph.value"
      align-v="center"
      class="ml-0"
    >
      <CheckBoxConfiguration
        :controller="IdependStadisticalEvalCtller"
        :switchprop="true"
      />
    </b-row>
    <b-row
      v-if="FitStepGraph.value"
      align-v="center"
      class="ml-0"
    >
      <CheckBoxConfiguration
        :controller="StandardAdditionCtller"
        :switchprop="true"
      />
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller, baseConfCtrller} from '@/assets/classes/configuration.js'
import FitSelection from './model/FitSelection'
import StatisticalEvaluation from './StatisticalEvaluation'
import { mapGetters, mapActions } from 'vuex'

const fitName = 'multiȲ'
const rootContextFolder='ReportViewer/Fit/' + fitName
const zoneNotify='MultiMeanFit'

export default {
  name: zoneNotify,
  components:{
    FitSelection,
    StatisticalEvaluation,
    CheckBoxConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      FitStepExpanded:true,
      StatisticalEvalExpanded:true,
      fitName,
      elementsConfig:[],
      FitStepGraph: new checkBoxGraphConfCtrller(`{0}.${ConfigName.StepFitPlot}`,'Fit Step Data',false,rootContextFolder+'StepFitGraph',true),
			ExtractedStadisticalEvalCtller: new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.showExtractedValues`,'Show extracted values',false,rootContextFolder+'ShoExtracted'),
			PredictTimeSeriesCtller: new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.RealTimePlot`,'Predict time series',false,rootContextFolder+'predictTimeSeries'),
			StandardAdditionCtller: new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.StandardAddition`,'Standard Addition',false,rootContextFolder+'StandardAddition'),
			IdependStadisticalEvalCtller: new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.SeparateStats`,'Independent Stat Evaluation',false,rootContextFolder+'IndependStatisticalEval'),
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.FitStepGraph,
			this.StandardAdditionCtller,
      this.ExtractedStadisticalEvalCtller,
			this.PredictTimeSeriesCtller,
      this.IdependStadisticalEvalCtller
    ]
    this.configureStudy()
    this.$watch(
      'FitStepGraph.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
  methods:{
    ...mapActions([
      'setGraphsConfWindow',
      'addInitReqConfWindow',
      'removeFromInitReqConfWindow'
    ]),
    configureStudy(){
      try{
        this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
        this.FitStepGraph.formatKeyValue(this.sectionconfig)
        this.FitStepGraph.setParent(this)
        this.verifyConfiguration()
      }catch(err){
        const errTitle='Error loading Multi Mean Fit'
        const errText=`Error loading Multi Mean Fit for ${this.sectionconfig}. Message: ${err}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
    },
    verifyConfiguration(){
      if(this.FitStepGraph.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
        const definedConcTimes = baseConfCtrller.getConfiguration(this.getCurrentReportViewer.configuration[this.sectionconfig], `${ConfigName.BaseCurveFit}.multiȲ.concTimes`)
        if(typeof(definedConcTimes) === 'undefined' || definedConcTimes.length === 0)
          this.addInitReqConfWindow({type:'CHRONO_VALUES', study: this.sectionconfig})
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
        this.removeFromInitReqConfWindow({type:'CHRONO_VALUES', study: this.sectionconfig})
      }
    },
    openCronoConfig(){
      this.setGraphsConfWindow([{ //Add the selected configuration to the Interfactive Configuration Pop-up
        type:'CHRONO_VALUES',
        study:this.sectionconfig
      }])
    }
  }
}
</script>

<style>

</style>